// /components/simulator/ResultSummaryCard.js

import TraditionalRentalSummary from './summaries/TraditionalRentalSummary';
import BankLendingSummary from './summaries/BankLendingSummary';
import RentToOwnSummary from './summaries/RentToOwnSummary';
import RentToOwnGoldSummary from './summaries/RentToOwnGoldSummary';
import RentToOwnRealEstateSummary from './summaries/RentToOwnRealEstateSummary';
import RentToOwnBusinessSummary from './summaries/RentToOwnBusinessSummary';
import RentToOwnStockSummary from './summaries/RentToOwnStockSummary';
import GoldInvestmentSummary from './summaries/GoldInvestmentSummary';
import StockInvestmentSummary from './summaries/StockInvestmentSummary';
import BusinessInvestmentSummary from './summaries/BusinessInvestmentSummary';

const ResultSummaryCard = ({ modelName, investorResult, borrowerResult }) => {





  switch (modelName) {
    case 'Traditional Rental':
      return <TraditionalRentalSummary investorResult={investorResult} borrowerResult={borrowerResult} />;
    case 'Bank Lending':
      return <BankLendingSummary investorResult={investorResult} borrowerResult={borrowerResult} />;
    case 'Rent-to-Own':
      return <RentToOwnSummary investorResult={investorResult} borrowerResult={borrowerResult} />;
    case 'Rent-to-Own + Gold':
      return <RentToOwnGoldSummary investorResult={investorResult} borrowerResult={borrowerResult} />;
    case 'Rent-to-Own + Real Estate':
      return <RentToOwnRealEstateSummary investorResult={investorResult} borrowerResult={borrowerResult} />;
    // case 'Rent-to-Own + Business':
    //   return <RentToOwnBusinessSummary investorResult={investorResult} borrowerResult={borrowerResult} />;
    case 'Rent-to-Own + Stock':
      return <RentToOwnStockSummary investorResult={investorResult} borrowerResult={borrowerResult} />;
    case 'Gold Investment':
      return <GoldInvestmentSummary investorResult={investorResult} borrowerResult={borrowerResult} />;
    case 'Stock Investment':
      return <StockInvestmentSummary investorResult={investorResult} borrowerResult={borrowerResult} />;
    // case 'Business Investment':
    //   return <BusinessInvestmentSummary investorResult={investorResult} borrowerResult={borrowerResult} />;
    default:
      return <div>Unknown model summary</div>;
  }
};

export default ResultSummaryCard;
